var React = require('react');

function AllServicesIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#E5E5E5"},React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M16 9v7H9V9h7zM7 9v7H0V9h7zm8 1h-5v5h5v-5zm-9 0H1v5h5v-5zM16 0v7H9V0h7zM7 0v7H0V0h7zm8 1h-5v5h5V1zM6 1H1v5h5V1z","transform":"translate(-427 -152) translate(284 136) translate(143 16)"}))))));
}

AllServicesIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = AllServicesIcon;

AllServicesIcon.default = AllServicesIcon;
